import {getMethod, postMethod} from '~/api'

async function post(request) {
    return await postMethod('/proxy/reservationsTableOptions', request)
}

async function get(request) {
    return await getMethod('/proxy/reservationsTableOptions', request)
}

export {post, get}
